export enum Result {
  SUCCESS,
  WARNING,
  ERROR,
  NOT_RUN,
  LAST_RUN,
  NONE
}
